<template>
    <div v-if="field">
        <b-button variant="primary" @click="editor = true">{{ $t('edit') }}</b-button> - <small>{{ pluralize(this.field.name, this.content.length, true) }}</small>
        <b-form-invalid-feedback :id="field.key" style="display:block">
            {{ errors[0] || null }}
        </b-form-invalid-feedback>
        <main-dialog v-model="editor" size="lg" :title="$translateLabel(field.label)" ok-only :ok-title="$t('save')" @ok="save" :hide-footer="$attrs.disabled">
            <b-button variant="success" @click="create" class="m-2" v-if="!$attrs.disabled">{{ $t('add') }}</b-button>
            <b-row>
                <b-col v-for="(cont, i) in content" :key="i" sm="12" md="6" lg="6">
                    <b-card >
                        <template #header v-if="!$attrs.disabled">
                            <i class="fa fa-trash float-right" @click="remove(i)"></i>
                        </template>
                        <div class="row" v-for="f in fields" :key="f.key">
                            <div class="col-sm-12">
                                <identity-field
                                    :name="f.name"
                                    :label="$translateLabel(f.label, f.name)" 
                                    :field="f" 
                                    :value="content[i]" 
                                    @error="fieldError" 
                                    :disabled="f.protected" 
                                    page="model_edit" 
                                    :extendErrors="httpErrors[f.key]" 
                                    @input="(e) => input(e, i)" 
                                    :store="store" 
                                    :context="context" 
                                />
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </main-dialog>
    </div>
</template>

<style scoped>
.fa-trash {
    cursor: pointer
}
</style>

<script>
import pluralize from 'pluralize'
import _ from 'lodash'

export default {
    name: "IdentityFieldFieldset",
    components: {
        'identity-field': () => import('../../IdentityFields.vue')
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Array,
            default: function() {
                return []
            }
        },
        store: {
            type: Object
        },
        context: {
            type: Object
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            fieldErrors: [],
            httpErrors: [],
            model: {},
            editor: false
        }
    },
    watch: {
        content: {
            handler: _.debounce(function(val) {
                this.check(val)
            }, 500),

            deep: true
        },

        field: {
            handler: _.debounce(function(val) {
                this.check(this.content)
            }, 500),

            deep: true
        }
    },
    computed: {
        content: {
            get() {
                console.log('get content', this.value)
                return this.value || []
            },

            set(val) {
                this.$emit('input', val)
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },

        fields() {
            return this.constraints.custom_data.fieldset
        }
    },
    methods: {
        input(val, objIdx) {
            this.httpErrors = []
            this.content[objIdx] = {...this.content[objIdx], ...val}
        },

        fieldError(error) {
            let found = this.fieldErrors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.fieldErrors.push(error)
            } else {
                this.fieldErrors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.fieldErrors.find((i, e) => {
                return i.error
            })
        },

        create() {
            let obj = {}

            this.fields.forEach(f => {
                obj[f.key] = null
            })

            let cont = this.content
            cont.push(obj)

            this.content = cont
        },

        remove(i) {
            this.$mainDialog.msgBoxConfirm(this.translator('areYouSure')).then(resp => {
                if (resp) {
                    this.content.splice(i, 1)
                    this.$emit('input', this.content)
                }

            })
        },

        save(e) {
            this.check(this.content)

            if (this.checkForErrors()) {
                e.preventDefault()
                return
            }

            this.$emit('input', this.content)
        },

        check(val) {
            val = val || []

            this.errors = []

            if (this.constraints.required) {
                if (val.length < 1) {
                    this.errors.push(this.translator("identityField.requiredField"))
                }

                if (this.checkForErrors()) {
                    this.errors.push(this.translator("invalidFields"))
                }

                this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
            }
        },

        pluralize: pluralize
    },

    mounted() {
        this.check(this.value)
    }

}
</script>